export default __webpack_public_path__ + "9fd6e9c7808226cac14ff39682c4c36c.png";